export const PROCESS_STEPS = [
    { n: "01", title: "UPLOAD", copy: "Choose your architectural plan." },
    { n: "02", title: "VISUALISE", copy: "Create a conceptual representation." },
    {
        n: "03",
        title: "ITERATE",
        copy: "Change materials, colours and architectural character.",
    },
    {
        n: "04",
        title: "SAVE",
        copy: "Keep visual concepts inside your project.",
    },
];

export const HERO_PLAN_IMG =
    "https://images.unsplash.com/photo-1542621334-a254cf47733d?q=80&w=1800&auto=format&fit=crop";
export const HERO_CONCEPT_IMG =
    "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?q=80&w=1800&auto=format&fit=crop";

export const CONCEPT_FRAMES = [
    {
        code: "EXT. 01",
        title: "EXTERIOR",
        image:
            "https://images.unsplash.com/photo-1774884736128-841eabe693ce?q=80&w=2400&auto=format&fit=crop",
        alt: "A dramatic modern home exterior",
        wrap: "lg:col-span-12",
        aspect: "aspect-[16/9] md:aspect-[21/9]",
    },
    {
        code: "ENT. 01",
        title: "ENTRANCE",
        image:
            "https://images.unsplash.com/photo-1776632001065-ad9efe3ee60e?q=80&w=1600&auto=format&fit=crop",
        alt: "A timber entrance door in a dark perforated facade",
        wrap: "lg:col-span-5",
        aspect: "aspect-[3/4]",
    },
    {
        code: "LIV. 01",
        title: "LIVING AREA",
        image:
            "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?q=80&w=1800&auto=format&fit=crop",
        alt: "A minimal living area with a large window",
        wrap: "lg:col-span-7",
        aspect: "aspect-[4/3]",
    },
    {
        code: "KIT. 01",
        title: "KITCHEN",
        image:
            "https://images.unsplash.com/photo-1632583824020-937ae9564495?q=80&w=1800&auto=format&fit=crop",
        alt: "A modern kitchen with dark cabinetry",
        wrap: "lg:col-span-7",
        aspect: "aspect-[4/3]",
    },
    {
        code: "BED. 01",
        title: "MASTER BEDROOM",
        image:
            "https://images.unsplash.com/photo-1696762932825-2737db830bbe?q=80&w=1600&auto=format&fit=crop",
        alt: "A master bedroom with warm timber headboard",
        wrap: "lg:col-span-5",
        aspect: "aspect-[3/4]",
    },
];

export const PROMPT_EXAMPLES = [
    {
        q: "“Make the exterior white with a charcoal roof.”",
        tag: "CONCEPT REVISION — 01",
        image:
            "https://images.unsplash.com/photo-1777104623084-1b36260d1577?q=80&w=1800&auto=format&fit=crop",
        alt: "White exterior with a charcoal roof",
    },
    {
        q: "“Show black aluminium windows.”",
        tag: "CONCEPT REVISION — 02",
        image:
            "https://images.unsplash.com/photo-1605018075968-b014b8d2e487?q=80&w=1800&auto=format&fit=crop",
        alt: "Black aluminium windows on a timber facade",
    },
    {
        q: "“Try a face-brick finish.”",
        tag: "CONCEPT REVISION — 03",
        image:
            "https://images.unsplash.com/photo-1495578942200-c5f5d2137def?q=80&w=1800&auto=format&fit=crop",
        alt: "Face-brick finish",
    },
];
